export default __webpack_public_path__ + "static/media/ice.16559ba4.svg";